import React from 'react'

import Box from 'react-bulma-components/lib/components/box'
import createPlotlyComponent from 'react-plotly.js/factory'
import Plotly from 'plotly.js-basic-dist'

import './Chart.sass'

const Plot = createPlotlyComponent(Plotly)

const data = {
  hoverinfo: 'text',
  marker: {
    color: '#5cb85c'
  },
  text: [],
  type: 'bar'
}

const layout = {
  autosize: true,
  hoverlabel: {
    bgcolor: '#ffffff'
  },
  xaxis: {
    automargin: true,
    fixedrange: true
  },
  yaxis: {
    title: '% difference from baseline',
    // range: [-80, 80],
    fixedrange: true
  }
}
const config = {
  displayModeBar: false,
  responsize: true
}

function variableDescription (descriptions, variable) {
  const varObj = descriptions.find(({ key }) => variable === key)
  return varObj ? varObj.description : ''
}

export default function Chart ({ values = [], title, descriptions, yrange }) {
  layout.title = title
  layout.yaxis.range = yrange
  data.x = []
  data.y = []
  data.text = []

  values.forEach(element => {
    data.x.push(element.label)
    data.y.push(element.change)
    data.text.push(`
      <b>${element.label}</b><br>
      ${variableDescription(descriptions, element.label)}<br>
      Change: ${element.change}%<br>
      Value: ${element.absolute}<br>
      Units: ${element.units}`
    )
  })
  return <Box className='chart'>
    <Plot data={[data]} layout={layout} config={config} />
  </Box>
}
